import React, { useEffect } from 'react';
import { isIOS, isAndroid } from 'react-device-detect';

import './style.less';

const CommunityDownloads = () => {
    useEffect(() => {
        if (isIOS) {
            window.location.href = 'https://apps.apple.com/us/app/speak2-community/id1596060585';
        } else if (isAndroid) {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.speak2software.community';
        }
    }, []);

    return (
        <div className="downloads-page">
            <img src={`${process.env.PUBLIC_URL}/logo.old.png`} alt="Speak 2 Logo" className="community-logo" />
            <h4>The app is available for download: </h4>
        <div className="app-links">
            <a href="https://play.google.com/store/apps/details?id=com.speak2software.community" className="play-store">
                <img
                    alt="Get it on Google Play"
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                />
            </a>
            <a href="https://apps.apple.com/us/app/speak2-community/id1596060585" className="app-store">
                <img src="/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"/>
            </a>
            </div>
        </div>
    );
};

export default CommunityDownloads;
